<template>
  <div class="flex q-pl-md">
    <AvatarGroupItem
      v-for="(item, idx) in list"
      :key="item.id"
      :name="getCompanyName(item)"
      :logo="getCompanyLogo(item)"
      :type="item.type"
      :style="{ zIndex: calculateZIndex(idx) }"
      :is-shipper-picture-empty="idx > 0 && !getCompanyLogo(list[idx - 1])"
    />
  </div>
</template>

<script>
import AvatarGroupItem from './AvatarGroupItem.vue';

export default {
  components: { AvatarGroupItem },

  props: {
    list: {
      type: Array,
      required: true,
    },
  },

  methods: {
    /**
     * Calculate z-index value in order to overlap avatars
     *
     * @param {number} index
     */
    calculateZIndex(index) {
      return this.list.length - 1 - index;
    },
    /**
     * Get company name
     *
     * @param {{tradingName?: string; businessName: string}} company
     */
    getCompanyName(company) {
      return company.tradingName || company.businessName;
    },
    /**
     * Get company logo image url
     *
     * @param {{profile?: {companyLogo: string}; companyLogo?: string}} company
     */
    getCompanyLogo(company) {
      return company.profile?.companyLogo ?? company.companyLogo;
    },
  },
};
</script>
